<template>
  <BootFiltros
    v-for="filtro in filtrosOrdenados"
    :key="filtro"
    :filtro="filtro"
    :component="filtro?.component"
    :path="path"
    :initialState="filtro?.initialState"
    :id="filtro?.filtro"
  />
</template>
<script>
import BootFiltros from '../components/BootFiltro.vue';
export default {
  name: 'Filtros',
  components: {
    BootFiltros
  },
  props: {
    filtros: {
      type: Array,
      required: true
    },
    path: {
      type: String,
      required: true
    }
  },
  computed: {
    filtrosOrdenados() {
      const ordem = this.$store.state.ordemFiltros || [];
      const filtrosOrdenados = ordem
        .map(filtroKey => this.filtros.find(f => f.filtro === filtroKey))
        .filter(Boolean);

      const filtrosRestantes = this.filtros.filter(filtro => 
        !ordem.includes(filtro.filtro)
      );

      return [...filtrosOrdenados, ...filtrosRestantes];
    }
  }
}
</script>
